// import { createSelector } from 'reselect';
// import _ from 'lodash';

const selBuilderOpen = state => state.companyAdmin.layout.builderOpen;

export default {
  builderOpen: selBuilderOpen,
};
